<!-- Type dd/mm/yyyy (slashes auto-inserted) or pick from the calendar, which has month and year dropdowns. Value is ISO yyyy-MM-dd. -->
@if (label) {
  <span class="date-label">{{ required ? label + ' *' : label }}</span>
}
<div class="date-wrap">
  <input
    type="text"
    class="date-input"
    inputmode="numeric"
    maxlength="10"
    autocomplete="off"
    [value]="text"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.aria-label]="label || 'Date'"
    (input)="onType($any($event.target).value)"
    (blur)="onBlur()"
  />
  <button type="button" class="date-toggle" [disabled]="disabled" aria-label="Open calendar" (click)="toggle()">
    <span class="material-symbols-outlined">calendar_month</span>
  </button>

  @if (open) {
    <div class="date-panel" [class.align-end]="alignEnd" [class.open-up]="openUp" role="dialog" aria-label="Choose date">
      <div class="cal-head">
        <button type="button" class="nav-btn" aria-label="Previous month" (click)="shiftMonth(-1)">
          <span class="material-symbols-outlined">chevron_left</span>
        </button>
        <select class="cal-select" aria-label="Month" (change)="setMonth($any($event.target).value)">
          @for (m of months; track m; let i = $index) {
            <option [value]="i" [selected]="i === viewMonth">{{ m }}</option>
          }
        </select>
        <select class="cal-select" aria-label="Year" (change)="setYear($any($event.target).value)">
          @for (y of years; track y) {
            <option [value]="y" [selected]="y === viewYear">{{ y }}</option>
          }
        </select>
        <button type="button" class="nav-btn" aria-label="Next month" (click)="shiftMonth(1)">
          <span class="material-symbols-outlined">chevron_right</span>
        </button>
      </div>

      <div class="cal-grid">
        @for (w of weekdays; track w) {
          <span class="weekday">{{ w }}</span>
        }
        @for (d of days; track d.date.getTime()) {
          <button
            type="button"
            class="day"
            [class.outside]="d.outside"
            [class.today]="isToday(d.date)"
            [class.selected]="isSelected(d.date)"
            [disabled]="d.disabled"
            (click)="pick(d)"
          >{{ d.date.getDate() }}</button>
        }
      </div>

      <div class="cal-foot">
        <button type="button" class="link-btn" (click)="clear()">Clear</button>
      </div>
    </div>
  }
</div>
